import type { IUserPublic } from '~/types/user'

import { capitalize } from './string'

type UserOption = IOption & {
  userData: {
    job?: string
    name: string
    picture?: string
  }
}

export const getUserOptions = (
  users: Pick<IUserPublic, 'name' | 'picture' | 'profile' | 'user_id'>[]
): UserOption[] => {
  return (
    users?.map(({ name, picture, profile, user_id }) => ({
      label: capitalize(name),
      userData: {
        job: profile?.job_title,
        name: capitalize(name),
        picture,
      },
      value: user_id,
    })) || []
  )
}

export const startsWithFilter = (option: IOption, filter: string): boolean => {
  if ('data' in option) {
    // @ts-expect-error react-select add label/value to data with custom option label used by getOptionLabel
    const { label, value } = option.data
    return label.toLowerCase().startsWith(filter.toLowerCase()) || value.toLowerCase().startsWith(filter.toLowerCase())
  } else {
    const { label, value } = option
    return label.toLowerCase().startsWith(filter.toLowerCase()) || value.toLowerCase().startsWith(filter.toLowerCase())
  }
}

/**
 * @param option A label and value that will be compared against the filter.
 * @param filter A string value entered by the user.
 * @return Returns true if the option value or label contains the filter (false if it doesn't).
 */
export const includesFilter = (option: IOption, filter: string): boolean => {
  if ('data' in option) {
    // @ts-expect-error react-select add label/value to data with custom option label used by getOptionLabel
    const { label, value } = option.data
    return label.toLowerCase().includes(filter.toLowerCase()) || value.toLowerCase().includes(filter.toLowerCase())
  } else {
    const { label, value } = option
    return label.toLowerCase().includes(filter.toLowerCase()) || value.toLowerCase().startsWith(filter.toLowerCase())
  }
}

export const formatAndSortOptionsFromStrings = (arr: string[]): { label: string; value: string }[] => {
  return arr.map((val) => ({ label: val, value: val })).sort((a, b) => a.label.localeCompare(b.label))
}

/** @doc It ensures the menu of a react-select input contained in a modal is positioned well */
export const reactSelectMenuPositionDef = (modalId: string): Record<string, any> => ({
  menuPortalTarget: document.querySelector(`#${modalId}`) as HTMLElement,
  menuPosition: 'fixed',
})
